var _rect, _rect2, _rect3, _path, _path2, _path3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _path4, _path5, _path6, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 385,
    viewBox: "0 0 424 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 37.0566,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 167.625,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 298.19,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.708 322.646C162.708 356.35 135.742 383.661 102.492 383.661C69.242 383.661 42.2764 356.35 42.2764 322.646C42.2764 288.942 69.242 261.631 102.492 261.631C135.742 261.631 162.708 288.942 162.708 322.646Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.453 192.079C379.453 225.783 352.488 253.094 319.238 253.094C285.988 253.094 259.022 225.783 259.022 192.079C259.022 158.376 285.988 131.065 319.238 131.065C352.488 131.065 379.453 158.376 379.453 192.079Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.39 61.5145C272.39 95.2181 245.425 122.529 212.175 122.529C178.925 122.529 151.959 95.2181 151.959 61.5145C151.959 27.811 178.925 0.5 212.175 0.5C245.425 0.5 272.39 27.811 272.39 61.5145Z",
    fill: "white",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212.821,
    cy: 61.3645,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.889,
    cy: 191.932,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.15,
    cy: 322.5,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 37.0566,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 167.625,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 298.19,
    width: 422.036,
    height: 51.2267,
    rx: 5.63289,
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.708 322.646C162.708 356.35 135.742 383.661 102.492 383.661C69.242 383.661 42.2764 356.35 42.2764 322.646C42.2764 288.942 69.242 261.631 102.492 261.631C135.742 261.631 162.708 288.942 162.708 322.646Z",
    fill: "#F6E5E9",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M379.453 192.079C379.453 225.783 352.488 253.094 319.238 253.094C285.988 253.094 259.022 225.783 259.022 192.079C259.022 158.376 285.988 131.065 319.238 131.065C352.488 131.065 379.453 158.376 379.453 192.079Z",
    fill: "#F6E5E9",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.39 61.5145C272.39 95.2181 245.425 122.529 212.175 122.529C178.925 122.529 151.959 95.2181 151.959 61.5145C151.959 27.811 178.925 0.5 212.175 0.5C245.425 0.5 272.39 27.811 272.39 61.5145Z",
    fill: "#F6E5E9",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.821,
    cy: 61.3645,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.889,
    cy: 191.932,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.15,
    cy: 322.5,
    r: 21.6963,
    fill: "white",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.4aeb3ef9c3419b3b292ca4917ef7b11c.svg";
export { ForwardRef as ReactComponent };